<div id="app">
  <img (click)="showMarkerArea()" id="sampleImage" width="100%" height="60%" #img [src]="sharedImage.data">
</div>
